function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.00098 13.251H12.1455C13.1572 13.251 13.8203 12.4854 13.8203 11.5625C13.8203 11.2891 13.752 11.002 13.6016 10.7354L8.52246 1.65039C8.20801 1.08301 7.64062 0.802734 7.07324 0.802734C6.50586 0.802734 5.9248 1.08301 5.61719 1.65039L0.544922 10.7422C0.387695 11.002 0.319336 11.2891 0.319336 11.5625C0.319336 12.4854 0.982422 13.251 2.00098 13.251ZM7.07324 8.75293C6.67676 8.75293 6.45117 8.52734 6.43066 8.12402L6.33496 5.25977C6.32129 4.84277 6.62891 4.54883 7.06641 4.54883C7.50391 4.54883 7.81836 4.84961 7.80469 5.2666L7.70215 8.12402C7.68164 8.53418 7.46289 8.75293 7.07324 8.75293ZM7.07324 11.1934C6.61523 11.1934 6.25977 10.8857 6.25977 10.4414C6.25977 9.99707 6.61523 9.68945 7.07324 9.68945C7.53125 9.68945 7.88672 9.99023 7.88672 10.4414C7.88672 10.8926 7.53125 11.1934 7.07324 11.1934Z",
  fill: "#F7BF57"
});

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.0a1955f3.svg";
export { ForwardRef as ReactComponent };